import { createRouter, createWebHistory } from "vue-router";
import agentOnboarding from "@/router/agent-onboarding";
import Login from "@/views/Login.vue";
import Register from "@/views/Register.vue";
import ForgotPassword from "@/views/ForgotPassword.vue";

import Console from "@/views/Console.vue";
import Dashboard from "@/views/console/Dashboard.vue";
import DNC from "@/views/console/DNC";
import NotFound from "@/views/NotFound.vue";

import brokerageRoutes from "@/router/brokerages";
import agentRoutes from "@/router/agents";
import lenderRoutes from "@/router/lenders";
import opportunityRoutes from "@/router/opportunities";
import userManagementRoutes from "@/router/user-management";
import supplierManagementRoutes from "@/router/supplier-management";
import qaReviewRoutes from "@/router/qa-review";
import announcementRoutes from "@/router/announcements";
import agentAssignmentRoutes from "@/router/agent-assignments";
import simulatorRoutes from "@/router/simulator";
import contentSearchRoutes from "@/router/content-search";
import twilioTasks from "@/router/twilio-tasks";
import bulkSmsSend from "@/router/bulk-sms-send";

import myAgentRoutes from "@/router/my-agents";
import myReferralRoutes from "@/router/my-referrals";
import myLeadRoutes from "@/router/my-leads";
import myNotificationRoutes from "@/router/my-notifications";
import myAnnouncementsRoutes from "@/router/my-announcements";
import myAdminsRoutes from "@/router/my-admins";
import myMetricsRoutes from "@/router/my-metrics";

//marketplace routes
import marketplaceRoutes from "@/router/marketplace";

import lenderLoanOfficersRoutes from "@/router/lender-loan-officers";
import lenderReferralRoutes from "@/router/lender-referrals";

// agent routes
import agentFollowups from "@/router/agent-followups";
import agentFunnel from "@/router/agent-funnel";
import agentProfile from "@/router/agent-profile";

import settings from "@/router/settings";

import store from "@/store/";
import C from "@/utils/constants";
import { inject } from "vue";

const routes = [
  ...agentOnboarding,
  {
    path: "/",
    name: "root",
    component: Login,
  },
  {
    path: "/login",
    name: "login",
    component: Login,
    meta: {
      skipReAuth: true,
    },
  },
  {
    path: "/register/:code*",
    name: "register",
    component: Register,
  },
  {
    path: "/forgot-password",
    name: "forgot",
    component: ForgotPassword,
  },
  {
    path: "/console",
    component: Console,
    meta: {
      requiresAuth: true,
    },
    children: [
      ...brokerageRoutes,
      ...agentRoutes,
      ...lenderRoutes,
      ...lenderLoanOfficersRoutes,
      ...lenderReferralRoutes,
      ...opportunityRoutes,
      ...userManagementRoutes,
      ...supplierManagementRoutes,
      ...qaReviewRoutes,
      ...announcementRoutes,
      ...agentAssignmentRoutes,
      ...simulatorRoutes,
      ...contentSearchRoutes,
      ...twilioTasks,
      ...bulkSmsSend,
      ...myAgentRoutes,
      ...myReferralRoutes,
      ...myLeadRoutes,
      ...myNotificationRoutes,
      ...myAnnouncementsRoutes,
      ...myAdminsRoutes,
      ...myMetricsRoutes,
      ...marketplaceRoutes,
      ...settings,
      ...agentFollowups,
      ...agentFunnel,
      ...agentProfile,
      {
        path: "",
        name: "console",
        component: Dashboard,
        meta: {
          roles: [
            C.ROLE.ADMIN,
            C.ROLE.BROKERAGE_ADMIN,
            C.ROLE.MANAGER,
            C.ROLE.QA_TEAM,
            C.ROLE.CSR_SUPERVISOR,
            C.ROLE.AGENT_ENGAGEMENT,
            C.ROLE.CSR,
            C.ROLE.LOAN_OFFICE_ADMIN,
          ],
          hotjar: true,
        },
      },
      {
        path: "dashboard",
        name: "dashboard",
        component: Dashboard,
        meta: {
          roles: [
            C.ROLE.ADMIN,
            C.ROLE.AGENT_ENGAGEMENT,
            C.ROLE.BROKERAGE_ADMIN,
            C.ROLE.CSR,
            C.ROLE.LOAN_OFFICE_ADMIN,
          ],
        },
      },
      {
        path: "dnc-list",
        name: "dnc-list",
        component: DNC,
        meta: {
          roles: [
            C.ROLE.ADMIN,
            C.ROLE.MANAGER,
            C.ROLE.QA_TEAM,
            C.ROLE.CSR_SUPERVISOR,
            C.ROLE.AGENT_ENGAGEMENT,
            C.ROLE.CSR,
          ],
        },
      },
    ],
  },
  { path: "/404", component: NotFound },
  { path: "/:catchAll(.*)", redirect: "/404" },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  console.log("()()()()()(()()()()()()()()");
  console.log(to.path);
  console.log(to.meta);
  console.log("()()()()()(()()()()()()()()");

  const app = inject("app");
  // console.log("!!!!!!!!!!!!! ROUTER !!!!!!!!!!!!!!!!!!!");
  // console.log(app.);
  // console.log("!!!!!!!!!!!!! ROUTER !!!!!!!!!!!!!!!!!!!");

  if (
    app.config.globalProperties.$hj &&
    to.meta?.hotjar &&
    store.getters["user/me"] !== null &&
    store.getters["user/me"].id
  ) {
    console.log("$$$$$ hotjar");
    app.config.globalProperties.$hj("identify", store.getters["user/me"].id, {
      email: store.getters["user/me"].email,
    });
  }

  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (
      store.getters["auth/session"] !== null &&
      store.getters["auth/session"].access_token !== null
    ) {
      // check session is expired
      if (store.getters["auth/sessionExpiresIn"] < 0) {
        next("/login");
      }

      // check roles and redirect accordingly
      let roles = store.getters["user/roles"];
      console.log("$$$$$$$$$$$$$ roles $$$$$$$$$$$$$$$$$$$$$$$$$$");
      console.log(roles);
      console.log("$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$");
      if (roles.filter((r) => to.meta.roles.indexOf(r) !== -1).length === 0) {
        if (to.path === "/console") {
          return next("/login");
        } else {
          // check default route for that role and redirect there
          if (roles.length > 0) {
            let role = roles[0];
            if (role in C.ROLE_DEFAULT_ROUTE) {
              console.log(
                `DEFAULT ROUTING ${role} TO ${C.ROLE_DEFAULT_ROUTE[role]}`,
              );
              return next(C.ROLE_DEFAULT_ROUTE[role]);
            } else {
              // TODO: Temporary catch-all need to alert and remain on login screen
              console.log("....UNMAPPED ROLE DEFAULT ROUTE....");
              console.log(role);
              console.log(".....................");
              return next("/console");
            }
          } else {
            console.log("*********** No Roles - Sending to Login ************");
            return next("/login");
          }
        }
      }

      console.log("............ router from ..............");
      console.log(from);
      console.log(".......................................");

      // skip re-auth (from login to other page)
      if (from.meta.skipReAuth) {
        console.log("********** skipping reauth ****************");
        next();
      } else {
        store
          .dispatch("auth/reAuth")
          .then((resp) => {
            console.log(".............re authed............");
            console.log(resp);
            console.log("..................................");
          })
          .catch((e) => {
            console.log(e);
            next("/login");
          });

        // go ahead and move onto next route
        next();
      }
    } else {
      next("/login");
    }
  } else {
    next();
  }
});

export default router;
